<template>
    <van-popup v-model='visibleDialog' position='bottom' closeable close-icon='close' :closeOnClickModal='false' :round='true'>
        <div class='sku'>
            <div class='sku_top'>
                <div class='sku_top_img'><img :src='$viewImageNew(skuGood.skuImgUrlList, 400,400)' alt=''></div>
                <div class='sku_top_title'>
                    <div class='sku_top_title_price'><sub>¥ </sub>{{ skuGood.salesPrice }}</div>
                    <div class='sku_top_title_cont' v-if="!type">商品编号：{{ skuGood.skuCode }}</div>
                    <div class='sku_top_title_content' v-if='spuInfo.spuName && getSpecsList.length'>已选：{{ spuInfo.spuName }}</div>
                </div>
            </div>
            <div class='sku_specs' v-if='getSpecsList.length || optionTypes.length'>
                <div class='sku_specs_h3' v-if='getSpecsList.length'>规格</div>
                <div class='sku_specs_div'>
                    <span v-for='item in getSpecsList' :key='item.spuId' :class="{'specAction': spuInfo.spuId === item.spuId}" @click="onSpecs(item)">{{item.spuShowName }}</span>
                </div>
                <div v-for='(item, index) in optionTypes' :key='index'>
                    <div class='sku_specs_h3'>{{ item.name }}</div>
                    <div class='sku_specs_div'>
                        <span v-for='it in item.optionValues' :key='it.id' :class="{
                                'specOption': optionSpecs.includes(it.id),
                                'specAction': specsS.includes(it.id),
                                'specDisabled': !optionSpecs.includes(it.id)
                            }" @click='handleClick(optionSpecs.includes(it.id), it.id, index)'>{{ it.name }}</span>
                    </div>
                </div>
            </div>
            <div class='sku_cart'>
                <div class='sku_cart_name'>购买数量<span v-show="skuGood.saleableStock">库存{{ skuGood.saleableStock }}件</span></div>
                <div class='sku_cart_cartNumber'>
                    <van-stepper v-model="skuGood.quantity" :min='skuGood.orderMinCount' :max='skuGood.maxVal' />
                </div>
            </div>
            <div class='sku_rebate'>{{ goodMore() }}</div>
            <div class='sku_buttom' v-if="skuGood.maxVal < skuGood.orderMinCount">
                <div class='sku_buttom_btn sku_buttom_dis'>缺货</div>
            </div>
            <div class='sku_buttom' v-else-if="!type">
                <div class='sku_buttom_btn sku_buttom_yellow' @click="onCart(1)">加入购物车</div>
                <div class='sku_buttom_btn sku_buttom_red' @click="onCart(2)">立即购买</div>
            </div>
            <div class='sku_buttom' v-else>
                <div class='sku_buttom_btn sku_buttom_yellow' @click="onJoin">立即加入</div>
            </div>
        </div>
    </van-popup>
</template>
<script>
import SpecAdjoinMatrix from '../../../utils/sku/spec-adjoin-martix'
import { Toast } from 'vant'
import { addShop } from '../api/api'
export default {
    props: {
        defActive: {
            type: Array,
            default: () => {
                return []
            }
        },
        visible: {
            type: Boolean,
            default: false
        },
        getSpecsList: { // 规格
            type: Array,
            default: () => {
                return []
            }
        },
        optionTypesArr: { // 属性
            type: Array,
            default: () => {
                return []
            }
        },
        skuDetailListArr: {
            type: Array,
            default: () => {
                return []
            }
        },
        skuGood: {
            type: Object,
            default: () => {
                return {}
            }
        },
        merchantCode: {
            type: String,
            default: ''
        },
        // 入口
        type: {
            type: String,
            default: ''
        },
        // spu名称
        spuInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    data () {
        return {
            specsS: [],
            optionSpecs: [],
            optionTypes: [],
            skuDetailList: [],
            userInfo: {},
            skuArr: ['', '', ''],
            skuLength: []
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible')
        },
        onSpecs (item) {
            this.$emit('onSpecs', item)
        },
        goodMore () {
            if (!this.skuGood.buyLimit && this.skuGood.orderMinCount > 1) {
                return this.skuGood.orderMinCount + '件起批'
            } else if (this.skuGood.buyLimit && this.skuGood.orderMinCount > 1) {
                return this.skuGood.orderMinCount + '件起批，限购' + this.skuGood.orderMaxCount + '件'
            } else if (this.skuGood.buyLimit && this.skuGood.orderMinCount < 2) {
                return '限购' + this.skuGood.orderMaxCount + '件'
            }
        },
        onJoin () {
            let skuShow = this.skuArr.findIndex(item => !item)
            if (this.optionTypesArr.length && !this.skuLength.length && skuShow >= 0) {
                let skuMessage = this.optionTypesArr[skuShow].name
                Toast('请选择' + skuMessage)
                return
            }
            this.$emit('update:visible')
            this.$emit('onJoin')
        },
        handleClick (bool, text, index) {
            // 排除可选规格里面没有的规格
            if (this.specsS[index] !== text && !bool) return
            // 根据text判断是否已经被选中了
            this.specsS[index] = this.specsS[index] === text ? '' : text
            this.specsS = this.specsS.slice()
            this.spec(this.specsS)
            this.getSelectSku(this.specsS)
        },
        // 获取选中状态下的sku
        getSelectSku (skuData) {
            this.skuArr = skuData
            let selectData = this.skuDetailList.filter(item => item.list.join('') === skuData.join(''))
            this.skuLength = selectData
            if (selectData.length) {
                let skuLength = selectData[0]
                this.skuClone(skuLength)
                this.$emit('selectData', skuLength)
            } else {
                this.$emit('initSkuGood')
            }
        },
        spec (arr = []) {
            // 创建一个规格矩阵
            const specAdjoinMatrix = new SpecAdjoinMatrix(
                this.optionTypes,
                this.skuDetailList
            )
            // 获得可选项表
            this.optionSpecs = specAdjoinMatrix.getSpecscOptions(arr)
        },
        optionSum (mapData) {
            return mapData.map(item => {
                let list = item.optionValues.map((it, index) => it.id)
                return {
                    ...item,
                    list: list
                }
            })
        },
        onCart (type) {
            let skuShow = this.skuArr.findIndex(item => !item)
            if (this.optionTypesArr.length && !this.skuLength.length && skuShow >= 0) {
                let skuMessage = this.optionTypesArr[skuShow].name
                Toast('请选择' + skuMessage)
                return
            }
            this.$emit('update:visible')
            if (type === 1) {
                this.addShop()
                if (this.$route.query.special) {
                    // this.$emit('getPoint', 60)
                }
            } else {
                this.$emit('buryPoint', 18)
                let skuList = [{
                    merchantCode: this.merchantCode,
                    skus: [
                        {
                            skuId: this.skuGood.skuId,
                            quantity: this.skuGood.quantity
                        }
                    ]
                }]
                localStorage.setItem('goodsData', JSON.stringify(skuList))
                this.$router.push({ path: '/b2b/order/confirmOrder' })
            }
        },
        async addShop () {
            this.$emit('buryPoint', 17)
            await addShop({
                memberCode: this.userInfo.companyCode,
                skuId: this.skuGood.skuId,
                quantity: this.skuGood.quantity
            })
            this.$emit('cartNums')
        },
        // sku来源及字段处理
        skuClone (skuLength) {
            if (this.type) {
                let skuQuery = skuLength.minimumOrderQuantity > skuLength.inventoryNum ? skuLength.inventoryNum : skuLength.minimumOrderQuantity
                skuLength.quantity = skuLength.quantity || skuQuery
                skuLength.minVal = skuLength.minimumOrderQuantity
                if (!skuLength.buyLimit) {
                    skuLength.maxVal = skuLength.inventoryNum
                } else {
                    let maxVal = skuLength.inventoryNum <= skuLength.orderMaxCount ? skuLength.inventoryNum : skuLength.orderMaxCount
                    skuLength.maxVal = maxVal
                }
            } else {
                let skuQuery = skuLength.orderMinCount > skuLength.saleableStock ? skuLength.saleableStock : skuLength.orderMinCount
                skuLength.quantity = skuLength.quantity || skuQuery
                skuLength.minVal = skuLength.orderMinCount
                if (!skuLength.buyLimit) {
                    skuLength.maxVal = skuLength.saleableStock
                } else {
                    let maxVal = skuLength.saleableStock <= skuLength.orderMaxCount ? skuLength.saleableStock : skuLength.orderMaxCount
                    skuLength.maxVal = maxVal
                }
            }
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.optionTypes = this.optionSum(this.optionTypesArr)
        this.skuDetailList = this.optionSum(this.skuDetailListArr)
        if (!this.optionTypes.length) {
            this.skuClone(this.skuGood)
        } else {
            if (this.defActive.length > 0) {
                this.specsS = this.defActive
                this.spec(this.specsS)
                this.getSelectSku(this.defActive)
            } else {
                this.spec()
                this.specsS = Array(this.optionTypesArr.length).fill('')
            }
        }
    }
}
</script>
<style lang='scss' scoped>
.sku {
    padding: 24px;
    &_top {
        display: flex;
        justify-self: start;
        padding-bottom: 40px;
        border-bottom: 2px solid #eeeeee;
        &_img {
            flex: 0 0 220px;
            height: 220px;
            display: flex;
            img {
                margin: 0 auto;
                justify-self: center;
                align-self: center;
            }
        }
        &_title {
            margin-left: 24px;
            display: flex;
            align-content: flex-end;
            flex-wrap: wrap;
            font-size: 24px;
            &_price {
                flex: 0 0 100%;
                font-size: 34px;
                color: #ff7a45;
                height: 48px;
                sub {
                    font-size: 22px;
                }
            }
            &_cont {
                flex: 0 0 100%;
                color: #333333;
                line-height: 36px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
            }
            &_content {
                flex: 0 0 100%;
                font-size: 22px;
                line-height: 30px;
                height: 60px;
                margin-top: 6px;
                color: #666666;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-wrap: break-word;
                word-break: break-all;
                overflow: hidden;
            }
        }
    }
    &_specs {
        padding-bottom: 40px;
        position: relative;
        height: 400px;
        overflow-y: auto;
        border-bottom: 2px solid #eeeeee;
        &_h3 {
            font-size: 24px;
            padding-top: 40px;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
        }
        &_div {
            font-size: 24px;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            span {
                border-radius: 10px;
                margin-top: 20px;
                margin-right: 8px;
                line-height: 60px;
                height: 60px;
                padding: 0 24px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                word-wrap: break-word;
                word-break: break-all;
                overflow: hidden;
                &.specOption {
                    background: #f5f5f5;
                    border: 2px solid #f5f5f5;
                }
                &.specAction {
                    background: #fff9f9;
                    border: 2px solid #ff7a45;
                }
                &.specDisabled {
                    background-color: #f3f3f3;
                    border: 2px solid #f3f3f3;
                    color: #bebebe;
                }
            }
        }
    }
    &_cart {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 28px;
        padding-top: 30px;
        &_name {
            span {
                font-size: 24px;
                color: #999999;
                margin-left: 24px;
            }
        }
    }
    &_rebate {
        font-size: 24px;
        color: #ff7a45;
        text-align: right;
        padding: 10px 0 40px;
    }
    &_buttom {
        display: flex;
        justify-content: center;
        font-size: 28px;
        padding-bottom: 16px;
        &_btn {
            width: 208px;
            line-height: 64px;
            border-radius: 64px;
            text-align: center;
            margin: 0 16px;
        }
        &_yellow {
            background: #ff7a45;
            color: #ffffff;
        }
        &_red {
            background: #ff4d4f;
            color: #ffffff;
        }
        &_dis {
            border: 2px solid #ccc;
            color: #fff;
            background: #ccc;
            width: 100%;
        }
    }
}
/deep/ .van-popup__close-icon {
    font-size: 48px;
}
/deep/ .van-stepper__minus::before,
/deep/ .van-stepper__plus::before,
/deep/ .van-stepper__minus::after,
/deep/ .van-stepper__plus::after {
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: currentColor;
    margin: inherit;
    transform: translate(-50%, -50%);
    content: "";
}
/deep/ .van-stepper__minus,
/deep/ .van-stepper__plus {
    width: 56px;
    height: 56px;
    padding: 8px;
}
/deep/ .van-stepper__minus::before,
/deep/ .van-stepper__plus::before {
    width: 50%;
    height: 2px;
}
/deep/ .van-stepper__plus::after {
    width: 2px;
    height: 50%;
}
/deep/ .van-stepper__input {
    width: 64px;
    font-size: 28px;
    height: 56px;
    margin: 0 4px;
    color: #323232;
}
</style>
